export default __webpack_public_path__ + "static/media/element5Card.fbbd0d3e.svg";